exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".head-tabs .ivu-radio-group[data-v-dc0e63e6]{height:100%}.head-tabs .ivu-radio-group .ivu-radio-wrapper[data-v-dc0e63e6]{height:32px;line-height:32px;border:none}.head-tabs .ivu-radio-group .ivu-radio-wrapper.ivu-radio-wrapper-checked[data-v-dc0e63e6]{color:#fff;background:#2d8cf0;border-radius:0}.head-tabs .ivu-radio-group .ivu-radio-wrapper[data-v-dc0e63e6]:before{content:\"\";display:none}.product-upload-list[data-v-dc0e63e6]{width:180px;height:180px}.product-upload-list-cover i[data-v-dc0e63e6]{margin:0 6px}.pictureBtn[data-v-dc0e63e6]{width:20px;height:100px;white-space:inherit;text-align:center;padding-right:24px}", ""]);

// exports
